export const currencies = ['EUR', 'GBP', 'USD', 'CHF'] as const
export type Currency = (typeof currencies)[number]

const rank: Record<Currency, number> = {
    CHF: 0,
    USD: 1,
    GBP: 2,
    EUR: 3
}

export function sortCurrencies(currencies: Currency[]): Currency[] {
    return [...currencies].sort((a, b) => rank[a] - rank[b])
}
export interface Money {
    value: number
    currency: Currency
}

export function isCurrency(value: unknown): value is Currency {
    if (typeof value !== 'string') return false
    return currencies.some((currency) => currency === value)
}

// A worker that keeps the currency as a string can send a code makalu does not know.
export const toCurrency = (code: string): Currency | undefined => (isCurrency(code) ? code : undefined)
